// extracted by mini-css-extract-plugin
export var addressFields = "_jr-0";
export var animationContainer = "_jr-1";
export var footer = "_jr-2";
export var lineItems = "_jr-3";
export var modalContent = "_jr-4";
export var orderName = "_jr-5";
export var strong = "_jr-6";
export var warning = "_jr-7";